import { makeStyles } from "@material-ui/core/styles";
const modalStyles = makeStyles((theme) => ({
  modalResponsive: {
  },
  modalResponsive1: {
   
  },
  modalResponsiveList: {
  }
}));
export default modalStyles;
